import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('UI Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8fafc',
          padding: 20,
          fontFamily: "'DM Sans', sans-serif",
        }}>
          <div style={{
            background: 'white',
            borderRadius: 20,
            padding: 32,
            maxWidth: 480,
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)',
          }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
            <h2 style={{ fontSize: 20, fontWeight: 800, color: '#1e293b', marginBottom: 8 }}>
              Une erreur est survenue lors de l'affichage
            </h2>
            <p style={{ fontSize: 14, color: '#64748b', marginBottom: 20 }}>
              {this.state.error?.message || 'Erreur d\'affichage'}
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              style={{
                padding: '12px 24px',
                background: '#4F46E5',
                color: 'white',
                border: 'none',
                borderRadius: 12,
                fontWeight: 800,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              🔄 Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
